import FaqView from "@/views/faq/FaqView";

export default { FaqView };
